// Service de tracking anonyme (RGPD-compatible)
// - Aucune donnée personnelle envoyée (pas d'IP, pas d'email, pas de user-agent)
// - session_id = UUID aléatoire en sessionStorage (non persistant, non traçable)
// - Fire-and-forget : n'en bloque jamais le parcours utilisateur

const SESSION_KEY = 'analytics_session_id';
const EVENT_NAMES = new Set([
  'landing', 'pricing', 'client_login_page', 'admin_login_page',
  'dashboard', 'ocr', 'chat', 'tva', 'documents', 'documents_fiscaux',
  'facturation', 'paie', 'social', 'urssaf', 'echeances', 'cadrage',
  'ecritures', 'cloture', 'bilan', 'inventaire', 'exports', 'tresorerie',
  'optimisation', 'creation_entreprise', 'abonnement', 'kbis',
  'login_client', 'login_admin', 'signup_client', 'signup_projet',
]);

const getSessionId = () => {
  try {
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = `${Date.now().toString(36)}-${Math.random().toString(36).substring(2, 14)}`;
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch (e) {
    return '';
  }
};

export const getAnalyticsToken = () => {
  try {
    return localStorage.getItem('auth_token') || '';
  } catch (e) {
    return '';
  }
};

/**
 * Enregistre un événement anonyme.
 * @param {string} eventType - 'page_view' | 'feature_use' | 'login' | 'signup' | 'error'
 * @param {string} eventName - un nom de la whitelist backend
 * @param {object} metadata  - { path?, duration_ms?, error_msg?, module? } (facultatif)
 */
export const track = (eventType, eventName, metadata = {}) => {
  if (!eventType || !EVENT_NAMES.has(eventName)) return;

  const payload = {
    event_type: eventType,
    event_name: eventName,
    session_id: getSessionId(),
    metadata: {
      ...(window.location?.pathname ? { path: window.location.pathname } : {}),
      ...metadata,
    },
  };

  try {
    const endpoint = '/analytics/track';
    const token = getAnalyticsToken();
    const init = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
      keepalive: true,
    };

    // fetch keepalive supporte les headers (Auth) contrairement à sendBeacon
    if (navigator.sendBeacon && !token) {
      navigator.sendBeacon(endpoint, new Blob([JSON.stringify(payload)], { type: 'application/json' }));
    } else {
      fetch(endpoint, init).catch(() => {});
    }
  } catch (e) {
    // Le tracking ne doit jamais casser l'application
  }
};

export const trackPageView = (eventName, metadata = {}) => track('page_view', eventName, metadata);
export const trackFeatureUse = (eventName, metadata = {}) => track('feature_use', eventName, metadata);
export const trackError = (eventName, errorMsg, metadata = {}) =>
  track('error', eventName, { ...metadata, error_msg: (errorMsg || '').slice(0, 500) });

export default track;
